import { render, staticRenderFns } from "./OwnerReport.vue?vue&type=template&id=1bb1c947"
import script from "./OwnerReport.vue?vue&type=script&lang=js"
export * from "./OwnerReport.vue?vue&type=script&lang=js"
import style0 from "./OwnerReport.vue?vue&type=style&index=0&id=1bb1c947&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports